import styles from './WidgetContentModal.module.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Loader } from '../Loader/Loader';
import cn from 'classnames';
import * as d3 from 'd3';
import { format, parseISO } from 'date-fns';
import { ExpandableText } from '../CollapsibleText/ExpandableText';
import { ReactComponent as ArrowIcon } from '../../pages/NarrativePage/assets/arrow.svg';
import { ReactComponent as ApproveIcon } from '../../pages/NarrativePage/assets/approve.svg';
import { ReactComponent as DeleteIcon } from '../../assets/delete.svg';
import { ReactComponent as LinkIcon } from '../../assets/link.svg';
import { ReactComponent as CalendarIcon } from '../../assets/calendar.svg';
import { ReactComponent as ViewsIcon } from '../../assets/views.svg';
import { ReactComponent as EngagementIcon } from '../../assets/engagement.svg';
import { ReactComponent as SimilarityIcon } from '../../assets/similarity.svg';
import { ReactComponent as FollowersIcon } from '../../assets/followers.svg';
import { ReactComponent as RecoverIcon } from '../../assets/recover.svg';
import { ReactComponent as EnvelopeIcon } from '../../assets/envelope.svg';
import { ReactComponent as EnvelopeOpenIcon } from '../../assets/envelopeOpen.svg';
import { ReactComponent as TranslationIcon } from '../../assets/translation.svg';
import { ReactComponent as OriginalTextIcon } from '../../assets/originalText.svg';
import { ReactComponent as ExpandIcon } from '../../assets/expand.svg';
import { ReactComponent as ChevronIcon } from '../../pages/SearchPage/assets/chevron-down.svg';
import { ReactComponent as ActorIcon } from '../../pages/SearchPage/assets/link.svg';
import { ReactComponent as SourceIcon } from '../../pages/SearchPage/assets/person.svg';
import { ReactComponent as HeartSolidIcon } from '../../assets/heart-solid.svg';
import { ReactComponent as HeartRegularIcon } from '../../assets/heart-regular.svg';
import { ReactComponent as SearchIcon } from '../../pages/SearchPage/assets/search.svg';
import { ReactComponent as SettingsIcon } from '../../assets/settings.svg';
import { decodeSourceName } from '../../utils/decodeURI';
import {platformIconsMapping, platformNamesMapping} from '../../utils/platforms';
import {contentTypesIconsMapping, contentTypesMapping} from '../../utils/contentTypes';
import Tooltip from '../Tooltip/Tooltip';
import { useCurrentUser } from '../../contexts/CurrentUser';
import { areAllIdsSelected } from '../../pages/NarrativePage/contexts/MessagesContext';
import { Sentiment } from '../Sentiment/Sentiment';
import { replaceNewlinesWithBreaks } from '../../utils/replaceNewlinesWithBreaks';
import { ImagesContainer } from '../Image/ImagesContainer';
import { DropdownMenu } from '../DropdownMenu/DropdownMenu';
import { ButtonsList } from '../DropdownMenu/ButtonsList';
import { formatNumber, formatNumberSignificant } from '../../utils/fomatNumbers';

import { LoaderSmall } from '../LoaderSmall/LoaderSmall';

import messageStyles from "../MessagesTable/ExtendedMessageView.module.scss";
import { API } from '../../API';
import { showRequestError } from '../../utils/requestError';

const opinionsAttitudeMap = {
  164652: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 100,
      counteract_share: 0,
      attitude: 'cooperate',
    },
  },
  164647: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 100,
      cooperate_share: 0,
      counteract_share: 0,
      attitude: 'attack',
    },
  },
  164649: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164645: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 100,
      cooperate_share: 0,
      counteract_share: 0,
      attitude: 'attack',
    },
  },
  164648: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 100,
      cooperate_share: 0,
      counteract_share: 0,
      attitude: 'attack',
    },
  },
  164654: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164664: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164653: {
    attitude_balance: {
      negotiate_share: 100,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 0,
      attitude: 'negotiate',
    },
  },
  164646: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 100,
      cooperate_share: 0,
      counteract_share: 0,
      attitude: 'attack',
    },
  },
  164651: {
    attitude_balance: {
      negotiate_share: 100,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 0,
      attitude: 'negotiate',
    },
  },
  164662: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164663: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164659: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164657: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164658: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164655: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164665: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 100,
      cooperate_share: 0,
      counteract_share: 0,
      attitude: 'attack',
    },
  },
  164656: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164661: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 0,
      counteract_share: 100,
      attitude: 'counteract',
    },
  },
  164650: {
    attitude_balance: {
      negotiate_share: 0,
      attack_share: 0,
      cooperate_share: 100,
      counteract_share: 0,
      attitude: 'cooperate',
    },
  },
};


const sortingFieldNames = {
  DATE: 'date_publicated',
  SOURCE: 'source',
  MESSAGE: 'text',
  VIEWS: 'impressions',
  REACTIONS: 'engagement',

  AGE: 'user_age',
  LOCATION: 'user_location',
  GROUPS: 'user_groups',
};



export const ModalOpinionsTable = ({
  messages,
  sorting,
  handleMessagesSortingClick,
  isLoading,
  isShare = false,
  handleTranslation,
  narrative,
  event,
  opinion,
  onMessageDelete
}) => {
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();
  const [isMessageDropdownOpen, setIsMessageDropdownOpen] = useState({});  

  const statusMapping = {
    NEW: {class: messageStyles.new, name: 'New'},
    READ: {class: messageStyles.approved, name: 'Approved'},
    DELETED: {class: messageStyles.deleted, name: 'Deleted'}
  };
  
  const [highlights, setHighlights] = useState(['KEYWORDS']);

  const handleDelete = (messageId) => {
    if(!opinion) {
      API.fetch('DELETE', `/API/v1/topic-modeling/${narrative.id}/events/${event.id}/messages/${messageId}`).then(() => {
        onMessageDelete()
      }).catch((e) => showRequestError(e, t('Delete publication')));
    } else {
      API.fetch('DELETE', `/API/v1/topic-modeling/${narrative.id}/events/${event.id}/opinions/${opinion.id}/messages/${messageId}`).then(() => {
        onMessageDelete()
      }).catch((e) => showRequestError(e, t('Delete publication')));
    }
  };

  const attitudeMapEvents = {
    'negotiate': (attitude_balance) => {
      return (
        <div className={styles.storyCardAttitudeBalanceNegotiation}>
          {attitudeMap[attitude_balance['attitude']]}
        </div>
      );
    },
    'attack': (attitude_balance) => {
      return (
        <div className={styles.storyCardAttitudeBalanceAttack}>
          {attitudeMap[attitude_balance['attitude']]}
        </div>
      );
    },
    'cooperate': (attitude_balance) => {
      return (
        <div className={styles.storyCardAttitudeBalanceCooperation}>
          {attitudeMap[attitude_balance['attitude']]}
        </div>
      );
    },
    'counteract': (attitude_balance) => {
      return (
        <div className={styles.storyCardAttitudeBalanceCounteraction}>
          {attitudeMap[attitude_balance['attitude']]}
        </div>
      );
    }
  };

  const attitudeMap = {
    'negotiate': t('Negotiate'),
    'attack': t('Attack'),
    'cooperate': t('Pivot'),
    'counteract': t('Counteract'),
  };

 
  return (
    <>
      {isLoading ? <Loader /> : messages?.objects?.length > 0 ? (
        <table className={messageStyles.extendedMessages}>
          <thead>
            <tr>
              <td className="message-controlls">
                {/* {currentUser?.is_super_admin === true ||
                (!isShare &&
                  ((narrative.is_threat &&
                    narrative.review_status === 'PENDING') ||
                    !narrative.is_threat)) ? (
                  <CheckboxField
                    onChange={() => toggleAll(messages, selectedMessages)}
                    checked={areAllIdsSelected(
                      messages?.objects,
                      selectedMessages,
                      true,
                    )}
                  />
                ) : (
                  ''
                )} */}
              </td>
              <td className={messageStyles.headerInfo}>
                <span>
                  {t('Total opinions')}: {formatNumber(messages.total)}
                </span>
              </td>
            </tr>
          </thead>
          <tbody>
            {messages?.objects.map((message) => {
              let followers_cnt = message?.source?.audience;
              let textClass = messageStyles.extendedMessage;

              if (message.error && message.isTranslation) {
                textClass = `${messageStyles.extendedMessage} ${messageStyles.error}`;
              } else if (message.error && !message.isTranslation) {
                textClass = messageStyles.extendedMessage;
              }

              const textForTranslation = message.highlighted_summary
                ? replaceNewlinesWithBreaks(message.highlighted_summary)
                : replaceNewlinesWithBreaks(message.summary);

              const messageAttitutdeBalance = opinionsAttitudeMap[message.id]?.attitude_balance;

              return (
                <tr key={message.id}>
                  <td className="message-controlls">
                    {/* {currentUser?.is_super_admin === true ||
                    (!isShare &&
                      ((narrative.is_threat &&
                        narrative.review_status === 'PENDING') ||
                        !narrative.is_threat)) ? (
                      <CheckboxField
                        checked={message.id in selectedMessages}
                        onChange={() => toggleSelected(message.id)}
                      />
                    ) : (
                      ''
                    )} */}
                  </td>
                  <td>
                    <div className={messageStyles.messageInfoWrapper}>
                      <div className={messageStyles.messageInfo}>
                        <div className={styles.storyCardOpinionBalanceContainer}>
                          <div className={styles.storyCardOpinionBalance}>
                            {attitudeMapEvents[messageAttitutdeBalance.attitude](messageAttitutdeBalance)}
                          </div>
                          
                        </div>
                      </div>
                      <div
                        className={
                          'open-message-popup ' + messageStyles.modalIcon
                        }
                      >
                        
                        <div className={messageStyles.totalDeduplicated}>
                          Total messages:{' '}
                          <span
                            className={messageStyles.totalDeduplicatedValue}
                          >
                            {formatNumber(message.messages_count)}
                          </span>
                        </div>
                       
                      </div>
                    </div>

                    <div className={messageStyles.messageContainer}>
                      <div></div>

                      <div className={messageStyles.textBlock}>
                        {message.isTranslation === true &&
                        !message.translated ? (
                          <div>
                            <LoaderSmall />
                          </div>
                        ) : (
                          <ExpandableText
                            length={100}
                            highlights={highlights}
                            text={
                              message?.isTranslation
                                ? message?.translated
                                : message?.title
                            }
                            textClassName={textClass}
                            onExpand={(expanded) => {
                              // ampli.track({
                              //   event_type: expanded
                              //     ? 'Expand story message in-place'
                              //     : 'Collapse story message in-place',
                              //   event_properties: {
                              //     user_id: currentUser?.id,
                              //     workspace_id: currentUser?.workspace_id,
                              //     narrative_id: narrative.id,
                              //   },
                              // });
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="message-controlls">
                    {/* {isShare ? (
                      ''
                    ) : (
                      <>
                        {currentUser?.is_super_admin === true ||
                        (!isShare &&
                          ((narrative.is_threat &&
                            narrative.review_status === 'PENDING') ||
                            !narrative.is_threat)) ? (
                          <div className={styles.controls}>
                            <button
                              className={`${messageStyles.approve} btn-primary`}
                              disabled={
                                message.status === 'DELETED' ? true : false
                              }
                              onClick={() => {
                                let status =
                                  message.status === 'NEW' ? 'READ' : 'NEW';
                                let messageIds = [message.id];
                                patchMessages(
                                  narrative,
                                  status,
                                  messageIds,
                                  deduplication,
                                ).then(() => {
                                  dispatch({ type: 'PATCH_MESSAGES' });
                                  getStories(
                                    narrative,
                                    searchQuery,
                                    start_date,
                                    end_date,
                                    statuses,
                                    sorting,
                                    page,
                                  );
                                });
                              }}
                            >
                              {message.status === 'NEW' ? (
                                <ApproveIcon />
                              ) : (
                                <EnvelopeOpenIcon />
                              )}
                            </button>
                            <button
                              className={`${messageStyles.delete} btn-danger`}
                              onClick={() => {
                                let messageIds = [message.id];
                                if (message.status === 'DELETED') {
                                  patchMessages(
                                    narrative,
                                    'NEW',
                                    messageIds,
                                    deduplication,
                                  ).then(() => {
                                    dispatch({ type: 'PATCH_MESSAGES' });
                                    getStories(
                                      narrative,
                                      searchQuery,
                                      start_date,
                                      end_date,
                                      statuses,
                                      sorting,
                                      page,
                                    );
                                  });
                                } else {
                                  deleteMessages(
                                    narrative,
                                    messageIds,
                                    deduplication,
                                    !isOpinions,
                                  ).then(() => {
                                    dispatch({ type: 'DELETE_MESSAGES' });
                                    getStories(
                                      narrative,
                                      searchQuery,
                                      start_date,
                                      end_date,
                                      statuses,
                                      sorting,
                                      page,
                                    );
                                  });
                                }
                              }}
                            >
                              {message.status === 'DELETED' ? (
                                <RecoverIcon />
                              ) : (
                                <DeleteIcon />
                              )}
                            </button>
                          </div>
                        ) : (
                          ''
                        )}
                      </>
                    )} */}

                    <div className={messageStyles.translationWrapper}>
                      <span
                        className={
                          message?.isTranslation ? '' : messageStyles.active
                        }
                        onClick={() =>
                          handleTranslation(
                            message.id,
                            textForTranslation,
                            false,
                          )
                        }
                      >
                        <OriginalTextIcon />
                      </span>
                      <span
                        className={
                          message?.isTranslation ? messageStyles.active : ''
                        }
                        onClick={() =>
                          handleTranslation(
                            message.id,
                            textForTranslation,
                            true,
                          )
                        }
                      >
                        <TranslationIcon />
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className={messageStyles.noData}>{t('There is no data to display')}</div>
      )}
    </>
  );
};
